import * as UI from "@iyk/ui"

import { ExclusiveCard } from "./exclusive-card.tsx"
import { Sheet } from "./sheet.tsx"
import { useExclusiveSheet } from "./use-exclusive-sheet.ts"

export const ExclusiveSweepstakeCard = (props: ExclusiveSweepstakeCard.Props) => {
  const [open, setOpen] = useExclusiveSheet(props.id)

  return (
    <Sheet.Root open={open} onOpenChange={setOpen}>
      <Sheet.Trigger>
        <ExclusiveCard.Container>
          <ExclusiveCard.CoverImage src={props.coverImage} alt={props.title} />

          <div className="absolute left-2 top-2">
            <SweepstakeBadge isWinner={props.isWinner} />
          </div>
          <ExclusiveCard.IconButton>
            <UI.Icon.Ticket />
          </ExclusiveCard.IconButton>

          <ExclusiveCard.Heading>
            <ExclusiveCard.Title>{props.title}</ExclusiveCard.Title>
            {props.subtitle && <ExclusiveCard.Subtitle>{props.subtitle}</ExclusiveCard.Subtitle>}
          </ExclusiveCard.Heading>
        </ExclusiveCard.Container>
      </Sheet.Trigger>
      <Sheet.Content title={props.title} description={props.description}>
        <div className="mx-4 mt-10 mb-8">
          <SweepstakeBadge isWinner={props.isWinner} />
          <p className="text-xl mt-2">{props.title}</p>
          <span className="text-xs text-gray-11">{props.announcementDate}</span>
          <p className="text-sm text-gray-12 mt-6">{props.description}</p>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

const SweepstakeBadge = ({ isWinner }: { isWinner: boolean }) => (
  <UI.Badge kind={isWinner ? "positive" : "outline"}>
    {isWinner ? "You won!" : "You're in the drawing"}
  </UI.Badge>
)

namespace ExclusiveSweepstakeCard {
  export type Props = {
    id: string
    title: string
    subtitle?: string
    coverImage: string
    isWinner: boolean
    announcementDate: string
    description: string
  }
}
